import Journeys from "./journeys"

export default Journeys
